import { FC, memo } from 'react'
import {
  SearchChatRoom,
  SearchChatRoomResultListItem,
} from './components/searchChatRoomResultListItem/searchChatRoomResultListItem'

export type SearchChatRoomListProps = {
  chatRooms: SearchChatRoom[] | null
}

// 検索したチャットルーム一覧を表示する
export const SearchChatRoomResultList: FC<SearchChatRoomListProps> = memo(
  (props) => {
    return props.chatRooms && props.chatRooms.length > 0 ? (
      <ul>
        {props.chatRooms.map((chatRoom) => (
          <SearchChatRoomResultListItem
            key={chatRoom.chatRoomId}
            chatRoom={chatRoom}
          />
        ))}
      </ul>
    ) : null
  }
)
